<template>
  <div class="container flex" v-if="isShow">
    <div id="test" class="flex ml10" v-show="!(modeType == 3)">
      <div class="leftNav mt10 flex1">
        <div style="width: 98%">
          <el-input placeholder="请输入名称查询" clearable v-model="company" @blur="searchcomp" prefix-icon="el-icon-search"></el-input>
        </div>
        <div style="height: 92%; overflow: auto">
          <el-menu default-active="1-1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
            <el-submenu :index="String(index + 1)" v-for="(item, index) in companyList1.length ? companyList1 : companyList" :key="index">
              <template slot="title">
                <i :class="'el-icon-folder' || 'el-icon-folder-opened'"></i>
                <span>{{ item.company }}</span>
              </template>
              <el-menu-item @click="checkCop(it)" :index="`${String(index + 1)}-${String(ind + 1)}`" v-for="(it, ind) in item.data" :key="ind">
                <i class="el-icon-document"></i>
                {{ it.area_name }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="content flex1" style="position: relative;">
        <div
          class="canvas"
          ref="can1"
          :style="{
            transform: 'scale(' + num + ')',
            position: 'absolute',
            height: '100%',
            width: '100%',
          }"
          @mousewheel="suo"
          @mousemove.stop="moveMouse"
          v-if="dwImg"
        >
          <!-- <AIMarker
            ref="aiPanel-editor"
            :readOnly="isdraged"
            :img-url="dwImg"
            @vmarker:onAnnoAdded="added"
            @vmarker:onAnnoSelected="selected"
            @vmarker:onUpdated="update"
            @vmarker:onReady="ready"
          ></AIMarker> -->
          <crtmarker ref="aiPanelEditor" :isBZ="true" @pointClick="pointSelect" @added="added" :imgUrl="dwImg" />
        </div>
      </div>
      <div class="rightnav mt10" style="width: 25%; height: 91%">
        <div style="width: 100%" class="center">
          <el-col :span="5">
            <el-button type="info" class="ml10" :disabled="!rightParams.area_uuid || !qvyuList.length" size="small" @click="downloadstair()">
              下载模板
            </el-button>
          </el-col>
          <el-col :span="5">
            <el-upload
              ref="upload"
              :limit="1"
              accept=".xlsx, .xls"
              :headers="upload.headers"
              :data="{ areaUUid: rightParams.area_uuid }"
              :action="upload.url + '?updateSupport=' + upload.updateSupport"
              :disabled="upload.isUploading || !rightParams.area_uuid || !qvyuList.length"
              :on-progress="handleFileUploadProgress"
              :on-success="handleFileSuccess"
              :auto-upload="true"
            >
              <el-button
                type="success"
                class="ml10"
                :disabled="!rightParams.area_uuid || !qvyuList.length"
                style="margin-top: 0px"
                size="small"
                v-hasPermi="['device:fireDoorDevice:import']"
                >上传文件
              </el-button>
            </el-upload>
          </el-col>
          <el-col :span="5">
            <router-link :to="`/qvyu/qvyu-place-add?area_uuid=${rightParams.area_uuid}&c_num=${rightParams.c_number}`">
              <el-button class="ml10" style="margin-top: 0px" size="small" type="primary" @click="reset" v-hasPermi="['device:fireDoorDevice:add']">
                新增楼梯
              </el-button>
            </router-link>
          </el-col>
          <el-col :span="5">
            <el-button class="ml10" style="margin-top: 0px" size="small" @click="changeModeType(3)">切换列表模式</el-button>
          </el-col>
        </div>
        <div v-if="tableType == 0">
          <div style="width: 100%; height: 90%; overflow: auto">
            <el-table :data="qvyuList" class="mt10" style="">
              <!-- <el-table-column prop="number" label="部位号" align="center">
          </el-table-column> -->
              <el-table-column prop="true_addr" label="设备名称" align="center">
                <template slot-scope="scope">
                  <div @click="changeRightMode(scope.row)" class="cursor">
                    {{ scope.row.true_addr }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" :type="scope.row.isMark ? 'warning' : 'primary'" icon="el-icon-edit" @click="markp(scope.row, scope.$index)"></el-button>

                  <el-popconfirm title="确定删除此点位吗？" class="cursor" @confirm="cancle(scope.row)" @onConfirm="cancle(scope.row)">
                    <a slot="reference" class="red">
                      <el-button type="danger" icon="el-icon-delete" size="mini"></el-button>
                    </a>
                  </el-popconfirm>
                  <el-button size="mini" type="info" icon="el-icon-video-camera" plain @click="markp(scope.row, scope.$index, true)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background v-if="rightNum > 10" layout="prev, pager, next" :page-size="rightParams.limit || 10" @current-change="pageChange" :total="rightNum">
          </el-pagination>
        </div>
        <div v-else style="height:100%">
          <div style="width: 100%; height: 90%; overflow: auto">
            <el-table fixed="left" :data="tablelist" class="mt10" style="">
              <!-- <el-table-column prop="number" label="部位号" align="center">
          </el-table-column> -->
              <el-table-column :label="item.label" v-for="(item, index) in tableList" align="center" :prop="item.prop" :key="index">
                <template slot-scope="scope">
                  <div>
                    <span v-if="index == 0"> {{ scope.row[item.label] + '层' }}</span>

                    <div v-else style="position:relative">
                      <div class="conten flex center">
                        <div :style="scope.row[item.label] == 1 ? { color: 'red' } : { color: '#000' }">
                          {{ scope.row[item.label + 'type'] == 3 ? '/' : scope.row[item.label + 'type'] }}
                        </div>
                        <div class="ml20">
                          <img src="@/assets/img/closed1.png" v-if="scope.row[item.label] == 1" style="width: 40px; height: 40px" />
                          <img src="@/assets/img/open1.png" v-if="scope.row[item.label] == 2" style="width: 40px; height: 40px" />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="mt20" style=" width: 100%;display: flex; justify-content: flex-end;text-align: right;">
            <el-button type="primary" size="mini" @click="changeRightMode(0)">返回列表</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="modeType == 3">
      <div class="container-list">
        <div class="flex1">
          <div class="common-page common-tool-bar">
            <el-row :gutter="10" class="mb8">
              <el-col :span="1.5">
                <el-button class="ml10" style="margin-top: 0px" size="small" @click="changeModeType(1)">切换平面图模式</el-button>
              </el-col>
            </el-row>
          </div>

          <el-table height="70vh" style="width:100%" v-loading="loading" :data="detaillist">
            <!-- <el-table-column type="selection" width="55" align="center" /> -->
            <el-table-column :label="item.label" v-for="(item, index) in detailList" v-if="index == 0" :fixed="index == 0 ? 'left' : false" width="150" :key="index" align="center">
              <template slot-scope="scope">
                <div>
                  <span v-if="index == 0"> {{ scope.row[item.label] + '层' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="item.label.substring(0, item.label.indexOf('楼梯'))"
              v-for="(item, index) in detailList"
              v-if="index !== 0 && index % 2 == 0"
              width="150"
              :key="index"
              align="center"
            >
              <el-table-column :label="detailList[index - 1].label.slice(-2)" width="150" :key="index - 1" align="center">
                <template slot-scope="scope">
                  <div class="cursor" @click="handleSelectAllItem(item.other)">
                    <div style="position:relative">
                      <div class="conten flex center">
                        <div :style="scope.row[detailList[index - 1].label] == 1 ? { color: 'red' } : { color: '#000' }">
                          {{ scope.row[detailList[index - 1].label + 'type'] == 3 ? '/' : scope.row[detailList[index - 1].label + 'type'] }}
                        </div>
                        <div class="ml20">
                          <img src="@/assets/img/closed1.png" v-if="scope.row[detailList[index - 1].label] == 1" style="width: 40px; height: 40px" />
                          <img src="@/assets/img/open1.png" v-if="scope.row[detailList[index - 1].label] == 2" style="width: 40px; height: 40px" />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column :label="detailList[index].label.slice(-3)" width="150" :key="index" align="center">
                <template slot-scope="scope">
                  <div class="cursor" @click="handleSelectAllItem(item.other)">
                    <div style="position:relative">
                      <div class="conten flex center">
                        <div :style="scope.row[detailList[index].label] == 1 ? { color: 'red' } : { color: '#000' }">
                          {{ scope.row[detailList[index].label + 'type'] == 3 ? '/' : scope.row[detailList[index].label + 'type'] }}
                        </div>
                        <div class="ml20">
                          <img src="@/assets/img/closed1.png" v-if="scope.row[detailList[index].label] == 1" style="width: 40px; height: 40px" />
                          <img src="@/assets/img/open1.png" v-if="scope.row[detailList[index].label] == 2" style="width: 40px; height: 40px" />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>

            <!-- <el-table-column label="状态: 1:开启 0:关闭" align="center" prop="status" /> -->
            <!-- <el-table-column label="备注" align="center" prop="remark" /> -->
          </el-table>
          <!-- 
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
  -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { AIMarker } from "vue-picture-bd-marker";
import crtmarker from '../../components/crtmarker';
import { mapState } from 'vuex';

import { getMapByid } from '../../api/common';
import config from '../../utils/config.js';
if (process.env.NODE_ENV == 'development') {
  //本地
  var wsUrl = config.wsUrltest;
} else if (process.env.NODE_ENV == 'production') {
  //线上
  var wsUrl = config.wsUrl;
}

export default {
  components: {
    crtmarker,
  },
  props: ['nowDevice'],
  computed: {
    ...mapState(['otherBjList']),
  },
  data() {
    return {
      num: 1,
      isdraged: true,
      add: false, //是否新增变化
      typeList: [], // 点位类型
      company: '', // 当前查询的公司
      companyList: [], //公司列表
      upload: {
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: 'Bearer ' + this.$local.get('token') },
        // 上传的地址
        url: this.$config.apiUrl + '/device/fireDoorDevice/import',
      },
      companyList1: [], //查询到的公司列表
      qvyuList: [], //区域列表
      pointList: [], //点位列表
      modeType: 1, // 1：平面图 3：全图列表
      tableType: 0, //0:点位列表 1:当前楼梯列表
      videoList: [], // 摄像头列表
      selectPoint: {}, // 选中的点位
      selectcomp: '',
      loading: false,
      detailList: [], // 全部列表的表头
      detaillist: [], // 全部大列表详情列表实际数据
      detailData: [],

      tableData: [], //  大列表接口返回的数据
      tableList: [], //代存的数据 单个数据
      tablelist: [], // 平面图模式列表渲染数据
      rightParams: {
        area_uuid: '',
        number: '',
        point_type: 243,
        true_addr: '',
        page: 1,
      },
      // 右侧楼梯列表uuid params
      stairparams: {
        areaUUid: '',
        stairDeviceNo: '',
      },
      rightNum: 10,
      warning: false,
      nowMessage: {},
      videoAddr: '',
      curObj: {}, // 当前查看的设备
      form: {}, //最终确定的点位
      dwImg: '',
      isShow: false,
    };
  },
  watch: {
    otherBjList(it) {
      if (it[0].areaUuid == this.rightParams.area_uuid) {
        this.nowMessage = it[0];
        this.getBigList();
        if (this.stairparams.stairDeviceNo == it[0].stairDeviceNo) {
          this.getRightStairList();
        }
      }
    },
    // isdraged(val){
    //   if(!val){
    //     // this.$message.warning('选择点位标注')
    //       this.setQuery('block')
    //   }else{
    //         this.getdwList()
    //     // this.$message.warning('退出点位标注')
    //       // this.setQuery('none')
    //   }
    // }
    // comara(val) {
    //   if (!val) {
    //     // this.videoList = [];
    //     this.curObj={}
    //   }
    // },
    nowDevice(val) {
      if (this.curObj && val && val.deviceType == 243) {
        if (this.curObj.areaUUid == this.rightParams.area_uuid) {
          var obj = { ...this.curObj, ...val };
          this.curObj = obj;
          this.getBigList();
          if (obj.staireId === this.stairparams.stairDeviceNo) {
            this.getRightStairList();
          }
        }
      }
    },
  },
  created() {
    getMapByid(176).then((res) => {
      this.typeList = res.data;
    });

    // 获取单位
    this.$post('/crt/crtmenu', { type: 2 }).then((res) => {
      if (res.data.length) {
        this.isShow = true;
        this.companyList = res.data;
        for (var i = 0; i < this.companyList.length; i++) {
          if (this.companyList[i].data.length) {
            this.checkCop(this.companyList[i].data[0]);
            break;
          }
        }
      } else {
        this.isShow = false;
        return this.$message.warning('该业务尚未开通，请联系管理员');
      }
    });
    // this.clearPoint(1)
    // this.setListData()
  },
  methods: {
    // 大列表点击楼梯是

    handleSelectAllItem(item) {
      this.qvyuList.map((it) => {
        if (it.id == item.stairDeviceNo) {
          this.changeRightMode(it);
        }
      });
    },
    // 点位点击时
    pointSelect(e) {
      this.qvyuList.map((it) => {
        if (e.point_uuid == it.point_uuid) {
          this.clearRightStairs();
          this.stairparams.areaUuid = this.rightParams.area_uuid;
          this.stairparams.stairDeviceNo = it.id;
          var obj = {};
          // alert(JSON.stringify())
          this.getRightStairList(it);
          this.tableType = 1;
        }
      });
    },
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },

    setListData(res, columnTable, dataTable) {
      var propArr = [];
      var dataArr = [];
      res.map((item, index) => {
        var dataObj = {};
        var payload = {};
        item.map((it, ind) => {
          // console.log(it, ind, 'get fireDoor name');
          if (index == 0) {
            var obj = {}; // 先遍历层数里的东西

            obj.label = it.fireDoorName;
            obj.id = ind;
            obj.floorLabel = '层数';
            obj.other = it;
            propArr.push(obj);
            if (ind == item.length - 1) {
              propArr.unshift({
                label: '层数',
                id: ind + 1,
              });
            }
          }
          dataObj[it.fireDoorName] = it.state;
          dataObj[it.fireDoorName + 'type'] = it.type;
          dataObj['层数'] = String(it.stairsNum);
        });
        dataArr.push(dataObj);
      });

      this[columnTable] = propArr;
      this[dataTable] = dataArr;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert(response.msg, '导入结果', { dangerouslyUseHTMLString: true });
      this.tableType = 0;
      this.getdwList();
      this.getBigList();
    },
    // 下载上传模板
    downloadstair() {
      this.downLoadExcel('/device/fireDoorDevice/export', { deviceId: '1', areaUUid: this.rightParams.area_uuid }, 'get', () => {});
    },
    // 列表模式切换
    changeModeType(tp) {
      this.modeType = tp;
      if (tp == 3) {
        this.changeRightMode(0, true);
      }
    },
    changeRightMode(tp, form) {
      if (tp) {
        this.stairparams.areaUuid = this.rightParams.area_uuid;
        this.stairparams.stairDeviceNo = tp.id;
        this.getRightStairList(tp);
      } else {
        this.clearRightStairs();
      }
      this.tableType = tp;
      if (!form) {
        this.changeModeType(1);
      }
    },
    // 设备开关
    handleChange(status) {
      var _this = this;
      this.$confirm(`确认要${status ? '开启' : '关闭'}${this.curObj.true_addr}设备吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(function() {
          // 设备开启
          _this
            .$put('/mqtt/mqttInfo/switchMQ', {
              deviceNo: _this.curObj.id,
              remark: status,
            })
            .then((res) => {
              this.$message({message: res.msg,type: "success", duration: 700,});
            });
        })
        .catch(function() {});
    },
    // changeFireStatus(isWaring, item) {
    //   this.warning = isWaring;
    //   this.nowMessage = item;

    //   this.startAnimate();
    // },

    // 重置山童

    resetAnimate() {
      var markers = document.getElementsByClassName('marker');
      for (var j = 0; j < markers.length; j++) {
        if (markers[j].classList.contains('animate')) {
          markers[j].classList.remove('animate');
        }
      }
    },

    startAnimate(detailAddr) {
      if (!this.pointList.length) {
        console.log('无数据');
        return;
      }

      var indx = null;
      var item = null;

      // if (!this.warning) {
      // console.log("取消闪动");
      // return;
      // }

      // if (this.warning) {
      console.log('收到报警 准备闪动 ');
      this.resetAnimate();

      setTimeout(() => {
        for (var i = 0; i < this.pointList.length; i++) {
          if (this.pointList[i].tag === detailAddr) {
            var animateClass = this.pointList[i].point_uuid;
            var markers = document.getElementsByClassName('marker');
            for (var j = 0; j < markers.length; j++) {
              if (markers[j].id === animateClass) {
                markers[j].className += ' animate';
                break;
              }
            }
            console.log('markers循环结束');
            break;
          }
          console.log('pointList 循环结束');
        }
      }, 50);
      // var divs = document.getElementsByClassName('tx-center')
      setTimeout(() => {}, 50);
      // }
    },

    pageChange(val) {
      // console.log(val)
      this.rightParams.page = val;
      this.getdwList();
    },
    reset() {
      this.rightParams.number = '';
      this.rightParams.true_addr = '';
      this.getdwList();
    },
    searchRight() {
      this.rightParams.number = this.rightParams.true_addr;
      this.getdwList();
    },

    playVideo() {},
    // clickPlayer(index) {
    //   this.videoIndex = index ? index : 0;
    //   var url = `${config.camraWs}?url=${this.videoList[index].content}`;
    //   this.playUrl = url
    //   this.handlePlay()
    // },

    // 获取监控列表

    // 获取萤石云的摄像头
    // getYS(arr){
    //   console.log(this.videoList)
    //    this.$get('basevideo/videotoken').then(Res=>{
    //      arr.map(item=>{
    //        // 如果是海康萤石云 获取网址 赋值iframe
    //         if(item.name==='海康萤石云'){
    //              item.vUrl = `ezopen://open.ys7.com/${item.number}/1.live&accessToken=${Res.data}`
    //               item.turn = 0
    //         }
    //         this.videoList.push(item)
    //       })
    //    })

    // },
    // 看坐标
    setQuery() {
      var name = this.isdraged ? 'none' : 'block';
      const markers = document.querySelectorAll('.g-image-op');
      for (var i = 0; i < markers.length; i++) {
        markers[i].style.display = name;
      }
    },
    // 搜素单位
    searchcomp() {
      this.companyList1 = [];
      if (!this.company) {
        return;
      }
      if (this.companyList.length) {
        this.companyList.map((item) => {
          if (item.company.indexOf(this.company) > -1) {
            this.companyList1.push(item);
          }
        });
      }
      (this.companyList1.length > 0 ? this.companyList1 : this.companyList)?.forEach((item) => {
        item.data[0] && this.checkCop(item.data[0]);
      });
    },
    //提交
    submit() {
      // return
      // if(this.form.point_uuid){
      //   var obj = {
      //     point_uuid:this.form.point_uuid,
      //     x_axis:this.form.position.x,
      //     xa_axis:this.form.position.x1,
      //     y_axis:this.form.position.y,
      //     ya_axis:this.form.position.y1
      //     }
      //     this.$post('crt/crtupdatedot',obj).then(res=>{
      //       this.$message.success('标点成功')
      //       this.form={}
      //       this.isdraged = !this.isdraged
      //       this.selectPoint=false
      //     })
      // }else{
      //   this.isdraged = !this.isdraged
      // }
    },

    //取消标点
    cancle(it) {
      if (this.selectPoint.point_uuid) {
        this.$message.error('请先标记已选择点位！');
        return;
      }
      var obj = {
        point_uuid: it.point_uuid,
        x_axis: '',
        xa_axis: '',
        y_axis: '',
        ya_axis: '',
      };
      this.$post('crt/crtupdatedot', obj).then((res) => {
        // this.$message.success('删除成功');
        this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        this.isdraged = true;
        this.getdwList();
      });
    },
    // 标点
    markp(it, ind, camra) {
      // var data = null
      // this.$refs['aiPanelEditor'].remove()
      // this.$refs['aiPanelEditor'].getBiaozhu(this.pointList)
      this.isdraged = false;

      if (!camra) {
        this.pointList.map((item) => {
          if (item.point_uuid === it.point_uuid) {
            if (this.selectPoint.point_uuid) {
              this.$message.warning('请先标记已选择点位！');
              return;
            }
            this.selectPoint = item;
            this.$refs['aiPanelEditor'].startBiaoZhu(this.selectPoint);
          }
        });

        this.setQuery();
      }
      if (camra) {
        this.viewcamra(it, ind);
      }
    },
    viewcamra(it) {
      this.videoAddr = it.true_addr;
      this.videoList = [];
      console.log(it);
      this.$get('/crt/crtInfoByCrtId', { id: it.id }).then((res) => {
        console.log(res);
        this.curObj = { ...res.data[0], ...it };
        console.log(this.curObj);
      });
      //   this.comara = true;
      //   this.getVideoList(it);
    },
    // 切换列表模式的接口口
    getBigList() {
      this.$get('/device/fireDoorDevice/listAll', {
        areaUuid: this.rightParams.area_uuid,
      }).then((res) => {
        console.log(res);
        this.tableData = res.data;
        this.setListData(res.data, 'detailList', 'detaillist');
      });
    },
    // 右侧楼梯小列表接口
    getRightStairList(it) {
      // console.log(JSON.stringify())
      this.startAnimate(it.number);

      this.$get('/device/fireDoorDevice/listByStairsNo', this.stairparams).then((res) => {
        this.detailData = res.data;
        this.setListData(res.data, 'tableList', 'tablelist');
      });
    },
    // setPoint(point) {
    //   this.$refs["aiPanel-editor"].getMarker().renderData(point);
    // },
    // clearPoint(){
    //   this.$refs["aiPanel-editor"].getMarker().clearData();
    // },
    //获取点位
    getdwList() {
      this.clearRightStairs();

      this.$post('/crt/crtRightStairs', this.rightParams).then((res) => {
        var companylist = [];
        var pointList = [];
        this.rightNum = res.data.count;
        res.data.list.map((item) => {
          var obj1 = {
            number: item.number,
            true_addr: item.device_name,
            point_uuid: item.point_uuid,
            id: item.id,
            isMark: item.x_axis ? true : false,
          };
          var obj2 = {
            tag: item.number,
            tagName: `<div>
                        楼梯名称:${item.device_name}<br/>
                        楼梯部位号:${item.number}
                        </div>`,
            x: item.x_axis,
            y: item.y_axis,
            type: item.point_type,
            point_uuid: item.point_uuid,
          };
          companylist.push(obj1);
          pointList.push(obj2);
        });
        this.qvyuList = companylist;
        this.pointList = pointList;
        // this.getPoint();
        this.$refs['aiPanelEditor']?.remove();
        this.$refs['aiPanelEditor']?.getBiaozhu(this.pointList);
        // this.changeFireStatus(this.warning, this.nowMessage);
      });
    },

    // 选择区域的点
    checkCop(it) {
      this.rightParams.area_uuid = it.area_uuid;
      this.rightParams.page = 1;
      this.rightParams.c_number = it.c_number;
      this.dwImg = it.image_name;
      this.tableType = 0;
      this.getdwList();
      this.getBigList();
    },
    //清除右侧楼梯列表数据
    clearRightStairs() {
      this.stairparams = {
        areaUUid: '',
        stairDeviceNo: '',
      };
      this.tableList = [];
      this.tablelist = [];
      this.detailData = [];
      this.resetAnimate();
    },
    //准备完成时
    ready() {
      // console.log(this.pointList)
    },
    //更新时
    update(v) {
      if (!this.add && this.selectPoint.point_uuid) {
        // 新增的变化
        this.form = {};
        this.form = { ...this.selectPoint, ...v[0] };
      } else {
      }
    },
    //添加标点时
    added(v) {
      this.selectPoint = {};
      this.$post('/crt/crtupdatedot', v).then((res) => {
        // this.$message.success('保存成功');
        this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
        this.getdwList();
        // this.draged
        this.isdraged = !this.isdraged;
      });
    },
    //选中标点时
    selected(v) {
      this.isdraged = false;
      this.selectPoint = v;
      this.form = this.selectPoint;
    },
    //滚轮缩小放大
    suo(v) {
      this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
      if (this.num < 0) {
        this.num = 0.1;
      }
    },

    //列表关闭是
    handleClose() {},
    // 列表展开是
    handleOpen() {},
    // 拖拽 目前还未使用
    moveMouse(e) {
      if (this.isdraged) {
        var ooid = this.$refs.can1; //获取目标元素

        ooid.onmousedown = function(event) {
          var dx = event.clientX - ooid.offsetLeft;
          var dy = event.clientY - ooid.offsetTop;

          ooid.onmousemove = function(event) {
            // console.log(event, 'move cursor to position');
            event = event || window.event;

            var left = event.clientX;
            var top = event.clientY;

            ooid.style.left = left - dx + 'px';
            ooid.style.top = top - dy + 'px';
          };

          ooid.onmouseup = function() {
            ooid.onmousemove = null;
            ooid.onmouseup = null;
          };
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 设置滚动条宽度和高度 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px; /* 横向滚动条 */
  height: 8px; /* 纵向滚动条 必写 */
}
/* 设置滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #dde;
  border-radius: 3px;
}

// 排风机
.controlFire {
  width: 430px;
  .eleButon {
    border: 1px solid #c0c0c0;
    padding: 4px 2px;
    width: 110px;
    border-radius: 15px;
  }

  .eleButonSelect {
    border: 1px solid #78b6ff;
  }

  .closeState {
    display: block;
    margin-top: 2px;
    width: 15px;
    height: 15px;
    background: #f2f2f2;
    box-shadow: 1px 1px #a6a6a6;
    border-radius: 50%;
  }
  .workState {
    background: #399022;
  }
  .stopState {
    background: #d0451b;
  }
  .leftImg {
    width: 280px;
    border: 2px solid #78b6ff;
    padding: 0 10px 10px;
  }
  .rightImg {
    width: 150px;
    border: 2px solid #78b6ff;
    border-left: none;
    padding: 10px;
  }
  .secondControl {
    // height: 90px;
    border: 2px solid #78b6ff;
    border-top: none;
    padding: 10px;

    .btnCont {
      display: flex;
      justify-content: space-around;

      .buttonCont {
        width: 60px;
        cursor: pointer;
        // border: 2px solid #000;
        color: #fff;
        height: 60px;
        // border-radius: 50%;
        display: flex;
        font-size: 16px;
        justify-content: center;
        align-items: center;
        // text-align: cener;
      }
      .disabledOpen {
        opacity: 0.5;
        width: 40px;
        height: 40px;

        font-size: 10px;
        cursor: default;
      }
    }

    .buttonOpen {
      background: repeating-radial-gradient(circle at center, #a1f1af, #399022);
    }
    .buttonClose {
      background: repeating-radial-gradient(circle at center, #ffe4d6, 30%, #eb0000);
    }
  }
}

.selectVideo {
  border: solid 2px red;
  height: 31.25rem;
  width: 37.5rem;
  position: relative;
}
::v-deep .selected {
  z-index: 99999;
}
::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}
::v-deep .g-image-op-del {
  display: none;
}
::v-deep .g-image-op-content {
  height: auto;
}
::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}
::v-deep .animate {
  animation: warningmove 0.6s infinite;
  position: absolute !important;
  /* z-index: 999999; */
}

@keyframes warningmove {
  from {
    background: yellow;
  }
  to {
    background: #ed1c24;
  }
}
.canvas {
  display: flex;
  align-items: center;
}
.container {
  height: 100%;
  max-height: 80vh;
  width: 100%;
  flex-direction: column;
  .topnav {
    height: 20%;
  }
  .leftNav {
    height: 100%;
    max-width: 23%;
  }
  #test {
    height: 100%;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 50%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      border: 1px solid gray;
    }
  }
}
</style>
